<template>
	<div>
		<v-card v-if="surroundWithCard" class="mx-auto" tile>
			<v-card-title class="subtitle-1 font-weight-bold pb-1">{{ title }}</v-card-title>
			<v-card-text>
				<v-data-table
					:headers="computedHeaders"
					:items="items"
					dense
					disable-sort
					disable-filtering
					disable-pagination
					hide-default-footer
					hide-default-header
					:mobile-breakpoint="mobileBreakPoint"
					class="viewerTableStyle"
					:header-props="{
						'sort-by-text': $t('$global.table.sort'),
					}"
				>
					<template slot="item.label" slot-scope="{ item }">
						<l-render v-bind="item.renderInput" :value="value" :__path="item.value">
							<template slot="default" slot-scope="{ label }"> {{ label }} </template>
						</l-render>
					</template>
					<template slot="item.value" slot-scope="{ item }">
						<l-render v-bind="item.renderInput" :value="value" :__path="item.value">
							<template slot="default" slot-scope="{ value: renderValue }">
								{{ renderValue }}
							</template>
						</l-render>
					</template>
					<template v-if="additionalExtendedItems" slot="body.append">
						<tr>
							<td>Erweitert</td>
							<td align="end">
								<v-btn icon @click="isExpanded = !isExpanded">
									<v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
								</v-btn>
							</td>
						</tr>

						<tr v-for="(item, index) in additionalExtendedItems" :key="index" :colspan="headers.length">
							<td v-if="isExpanded">
								<l-render v-bind="item.renderInput" :value="value" :__path="item.value">
									<template slot="default" slot-scope="{ label }"> {{ label }} </template>
								</l-render>
							</td>
							<td v-if="isExpanded" align="end">
								<l-render v-bind="item.renderInput" :value="value" :__path="item.value">
									<template slot="default" slot-scope="{ value: renderValue }">
										{{ renderValue }}
									</template>
								</l-render>
							</td>
						</tr>
					</template>
				</v-data-table>
				<slot name="extend" />
			</v-card-text>
		</v-card>
		<div v-if="!surroundWithCard">
			<v-data-table
				:headers="computedHeaders"
				:items="items"
				dense
				disable-sort
				disable-filtering
				disable-pagination
				hide-default-footer
				hide-default-header
				class="viewerTableStyle"
				:header-props="{
					'sort-by-text': $t('$global.table.sort'),
				}"
			>
				<template slot="item.label" slot-scope="{ item }">
					<l-render v-bind="item.renderInput" :value="value" :__path="item.value">
						<template slot="default" slot-scope="{ label }"> {{ label }} </template>
					</l-render>
				</template>
				<template slot="item.value" slot-scope="{ item }">
					<l-render v-bind="item.renderInput" :value="value" :__path="item.value">
						<template slot="default" slot-scope="{ value: renderValue }">
							{{ renderValue }}
						</template>
					</l-render>
				</template>
			</v-data-table>
			<slot name="extend" />
		</div>
	</div>
</template>

<script>
import { _BaseModel } from '@/plugins/clientModels';
import LRender from '@/components/base/LRender.vue';

export default {
	name: 'ViewerTable',
	components: { LRender },
	props: {
		value: {
			type: _BaseModel,
		},
		headers: {
			type: Array,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: false,
		},
		surroundWithCard: {
			type: Boolean,
			default: true,
		},
		mobileBreakPoint: {
			type: String,
			required: false,
		},
		additionalExtendedItems: {
			type: Array,
			required: false,
		},
	},
	data() {
		return { isExpanded: false };
	},
	computed: {
		computedHeaders() {
			if (this.headers.length !== 2)
				throw new Error('Invalid use of ViewerTable, there may be only 2 headers without "value" prop.');
			const computedHeaders = [];
			computedHeaders.push({ ...this.headers[0], value: 'label' });
			computedHeaders.push({ ...this.headers[1], value: 'value' });
			return computedHeaders;
		},
		computedItems() {
			return [...this.items, ...this.additionalExtendedItems];
		},
	},
};
</script>
